import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { Button } from '@mui/material';

interface Props {
  deletePost: () => void;
  onClose: () => void;
}

export const DeletePostModal = ({
  deletePost, onClose,
}: Props) => (
  <Dialog
    open
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">Are you sure you want to delete this post?</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        This action will delete this post and all of its credits.
        If you only want to remove the post from a profile, delete the corresponding credit.
        <br />
        <br />
        Deleting a post is permanent, it cannot be reimported.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="inherit">
        Cancel
      </Button>
      <Button onClick={deletePost} color="primary">
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);
